const initialState = {
  loaded: false,
  error: null,
  data: {
    countryCode: null,
    countryName: null,
    ip: null,
    isAllowed: false,
    isProxy: false,
    regionCode: null,
    regionName: null,
    timezoneName: null,
  },
}

export default initialState
